module.exports = __webpack_public_path__ + "img/curveButton.3899c76e.svg";